import styled from 'styled-components'
import { colors, etc } from 'li-components/lib/styles'
import SvgIcon from 'li-components/lib/SvgIcon'

export const Container = styled.div`
  display: flex;
  height: 4rem;
  margin: 0 1rem 0 1.5rem;
  font-weight: 400;
  border: 1px solid ${colors.inputBorderColor};
  border-radius: ${etc.inputBorderRadius};
`

export const Icon = styled(SvgIcon).attrs({
  name: 'search-1',
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 4rem;
  height: 100%;
  padding: 0 1rem;

  svg {
    fill: ${colors.grayLight};
    width: 2rem;
    height: 2rem;
  }
`

export const Input = styled.input`
  width: 100%;
  border: 0;

  &:focus {
    outline: 0;
  }
`

export const SelectContainer = styled.div`
  position: relative;
  padding-left: 1rem;
  border-left: 1px solid ${colors.inputBorderColor};
  cursor: pointer;

  select {
    appearance: none;
    width: auto;
    height: 100%;
    padding-right: 2.5rem;
    background-color: transparent;
    background-image: none;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;

    &:focus {
      outline: 0;
    }
  }
`

export const DropdownArrow = styled(SvgIcon).attrs({
  name: 'down-2',
})`
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: none;

  svg {
    fill: ${colors.grayLight};
    width: 1rem;
    height: 1rem;
  }
`



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Search/styled.js